import { useState } from "react";

export function useHistoryState<T>(key: string, initialValue: T): [T, (t: T) => void] {

  const [rawState, rawSetState] = useState<T>(() => {

    //const value = (history.state.state as any)?.[key];

    if (typeof window == 'undefined' || !((window as any).rus_state))
    {
        return initialValue;
    }


    const value = (window as any)?.rus_state[key];
    let v = value ?? initialValue;

    return v;
  });
  function setState(value: T) {

    if (typeof window == 'undefined')
    {
        rawSetState(initialValue);
        return;
    }


    if (!(window as any)?.rus_state)
    {
        (window as any).rus_state={};
    }

    (window as any).rus_state[key]=value;
    /*

    history.replaceState({
      ...history.state,
      state: {
        ...history.state,
        [key]: value
      
    }
        
    ,"");*/

    rawSetState(value);
  }
  return [rawState, setState];
}